import React from 'react'

const ResetPassword = () => {
    return (
        <div>
            <div>
                <p className='font-medium text-xl text-dark'>Reset password</p>
            </div>

            <div className='md:w-8/12 lg:w-5/12 mt-6 mb-10'>
                <div>
                    <input
                        type='password'
                        placeholder='Current password'
                        className='py-5 rounded-midxs placeholder-dark-100-light w-full text-sm'
                    />
                </div>
                <div className='my-10'>
                    <hr className='border-t-2 border-snow-100' />
                </div>
                <div>
                    <input
                        type='password'
                        placeholder='Enter new password'
                        className='py-5 rounded-midxs placeholder-dark-100-light w-full text-sm'
                    />
                </div>

                <div className='mt-5'>
                    <input
                        type='password'
                        placeholder='Confirm password'
                        className='py-5 rounded-midxs placeholder-dark-100-light w-full text-sm'
                    />
                </div>
                <div className='mt-5'>
                    <button className='w-full py-4 rounded-xs text-white bg-green font-medium mt-3'>
                        Reset password
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword
